module.exports = __webpack_public_path__ + "static/media/medloop-logo-white-copy.90f80e56.svg";